/* MG PRODUCT CARD — quick add + size picker + real Ajax Cart add.

   This store's assets/cart-drawer.js has a bug confirmed from its own
   source: <cart-drawer class="drawer{% if cart == empty %} is-empty{% endif %}">
   puts the "is-empty" class on the OUTER <cart-drawer> element, and CSS in
   component-cart-drawer.css keys off that outer class to lay out the empty
   state (cart-drawer.is-empty .drawer__inner{ display:grid; ... }). But
   CartDrawer.renderContents() only ever checks/removes "is-empty" from
   `.drawer__inner` — an element that never actually carries that class —
   so the real "is-empty" class on <cart-drawer> is never cleared. The new
   item DOES get inserted correctly by renderContents(), it's just visually
   broken by the stale empty-state grid layout left over from page load.
   Fix: call the theme's own renderContents() as normal (so header, items,
   totals, checkout button all update exactly like a native add-to-cart),
   then explicitly clear that stuck "is-empty" class ourselves. */
(function () {
  if (window.__mgProductCardInit) return;
  window.__mgProductCardInit = true;

  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartAddUrl = routesRoot.replace(/\/$/, '') + '/cart/add.js';
  var cartUrl = routesRoot.replace(/\/$/, '') + '/cart';

  function closeAllPanels(except) {
    document.querySelectorAll('[data-mg-qadd-panel]').forEach(function (panel) {
      if (panel !== except) panel.hidden = true;
    });
  }

  function getCartContainer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionsToRender(container) {
    if (container && typeof container.getSectionsToRender === 'function') {
      try {
        return container.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) { /* fall through to default */ }
    }
    return ['cart-icon-bubble', 'cart-drawer', 'cart-notification-product', 'cart-notification'];
  }

  // Clears the stale "is-empty" class the theme's own renderContents()
  // fails to remove (see file header). Also clears it from cart-drawer-items
  // defensively in case a given theme build has the same mismatch there.
  function clearEmptyState(container) {
    if (!container) return;
    container.classList.remove('is-empty');
    var items = container.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
  }

  function refreshCartIconOnly() {
    if (!document.getElementById('cart-icon-bubble')) return;
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (target && html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('cart-icon-bubble');
          if (fresh) target.replaceWith(fresh);
        }
      })
      .catch(function () {});
  }

  function addToCart(variantId, panel, sizeBtn, wrap) {
    sizeBtn.disabled = true;
    sizeBtn.style.opacity = '.6';
    var trigger = wrap && wrap.querySelector('[data-mg-qadd-trigger]');
    var cartContainer = getCartContainer();

    // Matches the theme's own product-form.js request shape (single id +
    // quantity, plus sections/sections_url) so the response is shaped
    // exactly the way renderContents() expects.
    var body = {
      id: parseInt(variantId, 10),
      quantity: 1,
      sections: sectionsToRender(cartContainer),
      sections_url: window.location.pathname
    };

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          var err = panel.querySelector('.mg-qadd-error');
          if (!err) {
            err = document.createElement('div');
            err.className = 'mg-qadd-error';
            panel.appendChild(err);
          }
          err.textContent = (res.data && res.data.description) || 'Could not add to cart.';
          sizeBtn.disabled = false;
          sizeBtn.style.opacity = '';
          return;
        }

        if (cartContainer && typeof cartContainer.renderContents === 'function') {
          try {
            cartContainer.renderContents(res.data);
          } catch (e) {
            window.location.href = cartUrl;
            return;
          }
          // renderContents() already calls this.open() internally, but the
          // stale "is-empty" class survives that call — clear it right after.
          clearEmptyState(cartContainer);
          // And once more on the next frame, in case renderContents' own
          // setTimeout(() => this.open()) runs after our fix and something
          // re-reads the class during that open/animate step.
          requestAnimationFrame(function () { clearEmptyState(cartContainer); });
        } else {
          refreshCartIconOnly();
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Give brief "Added" feedback on the trigger button itself instead
        // of replacing the panel's contents, so the size buttons are still
        // there and re-usable the next time this card is quick-added.
        panel.hidden = true;
        sizeBtn.disabled = false;
        sizeBtn.style.opacity = '';
        var errEl = panel.querySelector('.mg-qadd-error');
        if (errEl) errEl.remove();
        if (trigger) {
          var originalLabel = trigger.dataset.mgOriginalLabel || trigger.textContent;
          trigger.dataset.mgOriginalLabel = originalLabel;
          trigger.textContent = 'Added \u2713';
          trigger.classList.add('mg-is-added');
          clearTimeout(trigger.__mgAddedTimer);
          trigger.__mgAddedTimer = setTimeout(function () {
            trigger.textContent = originalLabel;
            trigger.classList.remove('mg-is-added');
          }, 1600);
        }
      })
      .catch(function () {
        sizeBtn.disabled = false;
        sizeBtn.style.opacity = '';
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mg-qadd-trigger]');
    if (trigger) {
      var wrap = trigger.closest('[data-mg-qadd]');
      var panel = wrap && wrap.querySelector('[data-mg-qadd-panel]');
      if (panel) {
        var willOpen = panel.hidden;
        closeAllPanels(willOpen ? panel : null);
        panel.hidden = !willOpen;
      }
      return;
    }

    var sizeBtn = e.target.closest('[data-mg-variant-id]');
    if (sizeBtn && !sizeBtn.disabled) {
      var panelEl = sizeBtn.closest('[data-mg-qadd-panel]');
      var wrapEl = sizeBtn.closest('[data-mg-qadd]');
      addToCart(sizeBtn.dataset.mgVariantId, panelEl, sizeBtn, wrapEl);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-mg-qadd]')) {
      closeAllPanels(null);
    }
  });
})();